

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './ControlPanel.css';
import withStyles from '../../decorators/withStyles';


class ControlPanel extends Component {

  render() {
    return(
      <div className={"ControlPanel " + this.props.className}>
        {this.props.children}
      </div>
    );
  };

}

export default withStyles(styles)(ControlPanel);
